import react from "react";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { Link } from "react-router-dom";

const QualityCheck = () => {
    return (


        <div className="">

            <div className="wrapper2">
                <h2 className="heading2">Quality Check</h2>
            </div>

            <section className="py-0">
                <div className="container py-0">
                    {/* more blogs */}
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">

                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/Quality-Check_banner.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay text-white p-3">
                                        <h1 className="fw-bold opacity-50" style={{ fontSize: "4rem" }}>03</h1>
                                    </div>
                                </div>
                            </div>


                            <p className="card-text text-muted py-3 px-2">
                                We ensure top-tier quality with rigorous testing and advanced technology,
                                guaranteeing milk that’s pure, safe, and free from undesirable substances like
                                antibiotics and additives. Real-time monitoring prevents adulteration and pilferage,
                                while sustainable practices like temperature control keep the milk fresh throughout
                                the production journey.
                            </p>
                            <div className="underline2"></div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bg-light">
                <div className="container p-3">
                    <h6 className="card-title fw-bold my-2">Quality Check Insights</h6>

                    <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">

                        <Link to="/technology-driven-quality-tests-2">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                                    <img src="img/Technology-Driven Quality Tests_.png" alt="" className="card-img-top" />
                                    {/* Dark overlay background */}
                                    <div className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ background: "rgba(0, 0, 0, 0.4)" }}>
                                    </div>
                                    {/* Text on top of overlay */}
                                    <div className="position-absolute text-overlay-f text-white p-3"
                                        style={{ zIndex: 1, top: "25%" }}>
                                        <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                                            Technology-Driven Quality Tests
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/sustainability-in-quality-assurance">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                                    <img src="img/Sustainability-in-Quality-Assurance_.png" alt="" className="card-img-top" />
                                    {/* Dark overlay */}
                                    <div className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ background: "rgba(0, 0, 0, 0.4)" }}>
                                    </div>
                                    {/* Text */}
                                    <div className="position-absolute text-overlay-f text-white p-3"
                                        style={{ zIndex: 1, top: "25%" }}>
                                        <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                                            Sustainability in Quality Assurance
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to='/cloud-connectivity-quality'>
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                                    <img src="img/Cloud-Connectivity_.png" alt="" className="card-img-top" />
                                    {/* Dark overlay */}
                                    <div className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ background: "rgba(0, 0, 0, 0.4)" }}>
                                    </div>
                                    {/* Text */}
                                    <div className="position-absolute text-overlay-f text-white p-3"
                                        style={{ zIndex: 1 }}>
                                        <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                                            Cloud Connectivity
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                    </div>
                </div>
            </div>

            <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
                <Link
                    to="/cloud-connectivity"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Previous
                </Link>
                <Link
                    to="/technology-driven-quality-tests-2"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Next
                </Link>

            </div>


        </div>


    );
};

export default QualityCheck;
